import Flickity from 'flickity';
import EventHandler from './EventHandler';
import cjs from './helpers/cjs';
import jQuery from 'jquery';
export default class DynamicTestimonials {
    constructor(section) {
        this.$el = section.el;
        this.$window = jQuery(window);
        this.flickity = null;
        this.events = new EventHandler();
        this.carousel = this.$el.querySelector('.testimonials');
        this.slides = this.$el.querySelectorAll('.testimonial');
        this.onBreakpointChange = () => {
            if ((cjs.max('XS') && this.slides.length > 1) || (cjs.max('L') && this.slides.length >= 3) || (cjs.min('XL') && this.slides.length > 3)) {
                this._initFlickity();
            }
            else {
                this._destroyFlickity();
            }
        };
        this.onBreakpointChange();
        cjs.onChange(this.onBreakpointChange);
    }
    onSectionUnload() {
        this._destroyFlickity();
        cjs.offChange(this.onBreakpointChange);
        this.events.unregisterAll();
    }
    _initFlickity() {
        if (this.flickity) {
            return;
        }
        this.flickity = new Flickity(this.carousel, {
            autoPlay: 0,
            accessibility: true,
            cellAlign: 'left',
            cellSelector: '.testimonial',
            groupCells: true,
            pageDots: true,
            contain: true,
            adaptiveHeight: false,
            arrowShape: 'M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z',
        });
        this.events.register(this.carousel, 'rimg:load', () => {
            var _a;
            (_a = this.flickity) === null || _a === void 0 ? void 0 : _a.resize();
        });
    }
    _destroyFlickity() {
        if (!this.flickity) {
            return;
        }
        this.flickity.destroy();
        this.flickity = null;
    }
}
